import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

// Components
import { AppComponent } from './app.component';
import { AdminLayout, UserLayout, UserAuthenticationLayout, BlankLayout } from './layouts';

@NgModule({
  declarations: [
    AppComponent,

    // Layouts
    UserLayout,
    UserAuthenticationLayout,
    BlankLayout,
    AdminLayout
  ],
  imports: [
    CoreModule,
    SharedModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
